import _ from 'lodash'
import React from 'react'
import {IoLinkSharp} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {eventModel} from '../../../apis/model'
import {CalendarIcon} from '../../../components/AppIcon'
import Translate from '../../../modules/local/Translate'
import {renderIf, renderIfElse} from "../../Shared";
import getTitle from "../../../helpers/getTitle";
import getLinkToDetail from "../../../helpers/getLinkToDetail";
import {parseDayjs, renderFromToTime} from "../../../helpers/datetimeHelpers";
import {ItemInformation} from 'components/common/ItemInformation'
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {BiSolidMapPin} from "react-icons/bi";
import {GoDotFill} from "react-icons/go";
import {RiMapPinTimeFill} from "react-icons/ri";
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

export const renderEventItem = (e) => {

    if (!e) return null

    const startDate = parseDayjs(_.get(e, 'time_open'))
    const endDate = !!_.get(e, 'time_close') ? dayjs(_.get(e, 'time_close')) : null
    const _eventType = _.get(e, 'event_type', 'meeting')

    const {owner, description, time_open, time_close} = e ?? {}

    const renderStatus = (startDate, endDate) => {
        if (!startDate || !endDate) return null;

        const now = dayjs();

        const isLive = now.isBetween(
            startDate,
            endDate,
            'minute',
            '[]'
        );

        const isIncoming = now.isBetween(
            dayjs(startDate).subtract(1, 'day'),
            dayjs(startDate),
            'minute',
            '[]'
        );

        if (isLive) {
            return (
                <span className="uppercase font-bold text-sm text-red-500 mr-3">
        <span className="blobs-container">
          <span className="blob red" />
        </span>
                    {'LIVE'}
      </span>
            );
        }

        if (isIncoming) {
            return (
                <span className="uppercase font-bold text-sm text-yellow-500 mr-3">
        <span className="blobs-container">
          <span className="blob yellow" />
        </span>
                    {'INCOMING'}
      </span>
            );
        }

        return null;
    };


    if (_eventType === 'reminder') {
        return (
            <Translate>
                {(t) => (
                    <div key={e.id} className="flex flex-col">
                        <div className="flex items-center gap-2">
                            <CalendarIcon time={e.time_open} className="mt-2 md:mt-0"/>
                            <div className="flex flex-col flex-1">
                                <Link
                                    to={eventModel.getLinkToDetail(e)}
                                    className="font-bold text-sm text-color-100 leading-tight no-underline">
                                    {e.title}
                                </Link>
                                <div className="space-x-1 text-xs italic">
                                    <span className="text-color-500 whitespace-no-wrap">{t('organized by')}</span>
                                    <Link to={getLinkToDetail(owner)}
                                          className="font-medium text-color-100 no-underline">
                                        {getTitle(owner)}
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="text-xs text-color-300 max-lines-2 italic leading-tight mt-1">
                                {description}
                            </div>
                            {!!e.external_link && (
                                <div className="flex items-center gap-1 text-xs">
                                    <div className="flex items-center justify-center">
                                        <IoLinkSharp/>
                                    </div>
                                    <div className="text-xs text-color-400">
                                        {e.external_link}
                                    </div>
                                </div>
                            )}
                            <div className="flex gap-1 text-2xs italic">
                    <span className="text-color-400">
                      {t('start')} {' : '}
                    </span>
                                <span className="flex-1 font-medium text-color-100">
                      {startDate?.format('HH:mm - DD/MM/YYYY')}
                    </span>
                            </div>
                        </div>
                    </div>
                )}
            </Translate>
        )
    }

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate>
                    {(t) => (
                        <div key={e.id} className="py-2 flex flex-col gap-2 custom-render-border relative">
                            <div className="flex items-center gap-3">
                                <CalendarIcon time={e.time_open}/>
                                <div className="flex flex-col">
                                    <Link
                                        to={eventModel.getLinkToDetail(e)}
                                        className="font-bold text-color-000 no-underline">
                                        {renderStatus(startDate, endDate)}
                                        {e.title}
                                    </Link>
                                    <div className="space-x-1 text-xs italic">
                                        <span className="text-color-500 whitespace-no-wrap">{t('organized by')}</span>
                                        <Link to={getLinkToDetail(owner)}
                                              className="font-medium text-blue-500 no-underline">
                                            {getTitle(owner)}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1 flex-1">
                                <div className="flex flex-col gap-y-1">
                                    <ItemInformation
                                        showIcon={true}
                                        label="type of event"
                                        value={t(e?.event_type)}
                                        className="text-xs italic"
                                    />
                                    <div className="flex items-center gap-1 text-xs italic">
                                        {renderIfElse(
                                            isSm,
                                            <RiMapPinTimeFill size={12} className="text-color-500"/>,
                                            <GoDotFill size={10} className="text-color-500"/>
                                        )}
                                        {renderIf(
                                            !isSm,
                                            <span className="text-color-500">
                                {`${t('time takes place')} : `}
                              </span>
                                        )}
                                        <span className="font-semibold text-color-100 leading-tight">
                            {renderFromToTime(time_open, time_close)}
                          </span>
                                    </div>
                                </div>
                                {renderIf(
                                    !!e.location_name,
                                    <div className="flex items-center gap-1 text-xs italic">
                                        {renderIfElse(
                                            isSm,
                                            <BiSolidMapPin size={12} className="text-color-500"/>,
                                            <GoDotFill size={10} className="text-color-500"/>
                                        )}
                                        {renderIf(
                                            !isSm,
                                            <span className="text-color-500">
                                  {`${t('address')} : `}
                                </span>
                                        )}
                                        <span className="font-semibold text-color-100 leading-tight">
                              {e.location_name}
                            </span>
                                    </div>
                                )}
                                {renderIf(
                                    description,
                                    <div className="text-xs text-color-300 max-lines-2 leading-snug">
                                        {description}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>
    )
}
